import React, { useState, useEffect } from "react";
import Modal from "../../../../../../Component/Containers/Modal";
import Loader from "../../../../../../Component/Loader";
import { showToast } from "../../../../../../Component/Toast";
import { post } from "../../../../../../Model/Config/Axios";
import FareRules from "./FareRules";

function Fares({ selected, fares, onClick, flight, retailFare }) {
  const [Rules, SetRules] = useState(undefined);
  const [selectedFlight, setselectedFlight] = useState(undefined);

  const [fareRuleModel, setFareRuleModel] = useState(false);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (selectedFlight) {
      fetchReview();
    }
  }, [selectedFlight]);

  const fetchReview = () => {
    post(
      `/flight/domestic/review`,
      {
        fareId: selectedFlight?.fare.key,
        inventoryId: selectedFlight?.flight.key,
      },
      (e, r) => {
        if (r.errors) {
        } else if (r) {
          fetchRules();
        } else if (e) {
          showToast({
            type: "error",
            message: e.data
              ? e.data.message
              : "Problem in fetching flight details, try again",
          });
        }
      }
    );
  };

  const fetchRules = () => {
    post(
      `/flight/domestic/rules`,
      { fareId: selectedFlight?.fare.key, inventoryId: selectedFlight?.flight.key },
      (e, r) => {
        if (r.errors) {
        } else if (r) {
          SetRules(r);
        } else if (e) {
        }
      }
    );
  };

  const [Expand, setExpand] = useState(false);
  return fares.map((fare, index) => {
    let percentOff = Math.floor(
      ((retailFare - fare.adult.publishedFare) * 100) / retailFare
    );

    if (index === 0) {
      return (
        <>
        <div
          onMouseOver={() => setExpand(true)}
          onMouseOut={() => setExpand(false)}
          onClick={() =>
            selected && selected.key === fare.key
              ? onClick(undefined)
              : onClick({ flight: flight, fare: fare })
          }
          className={`${
            selected && selected.key === fare.key ? "fares-selected" : "fares"
          } p-3 ps-4 pe-4 border-top position-relative`}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6 className="fw-bold me-3 mb-0">
                {fare.type.replace("_", " ")}
              </h6>
              <div className="d-flex flex-wrap align-center mt-2">
                <div className="text-small" style={{ marginRight: 12 }}>
                  🤑 {parseInt(fare.adult.publishedFare / 10, 10)} coins
                </div>
              </div>
            </div>
            <div className="text-end">
              <h6
                className={`fw-bold text-nowrap text-end ${
                  index === 0 ? "text-success" : ""
                }`}
              >
                Rs. {Math.ceil(fare.adult.publishedFare)} /{" "}
                <i className="fas fa-user" />
              </h6>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: 14,
                  color: "gray",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setselectedFlight({ flight: flight, fare: fare });
                  setFareRuleModel(true);
                }}
              >
                View Details
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {retailFare && percentOff ? (
                  <div
                    style={{ display: "inline" }}
                    className="p-1 ps-2 pe-2 text-nowrap rounded-pill bg-success text-white text-tiny"
                  >
                    {percentOff}% Off
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          {Expand ? (
            <div className="poition-relative">
              {fare.message ? (
                <div className="text-muted text-truncate text-tiny mt-1">
                  {fare.message}
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : fares.length - 1 > 0 ? (
            <div className="d-flex align-items-center justify-content-center mb-1">
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setExpand(!Expand);
                }}
                className="border rounded-pill ps-2 pe-2 text-small bg-light position-absolute"
                style={{
                  bottom: "0.5rem",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                + {fares.length - 1} more
                <i className="fa fa-chevron-down ms-1" />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        {fareRuleModel && (
          <Modal
            onClose={() => setFareRuleModel(false)}
            title="Flight  details"
            noButtons={true}
          >
            <div className="d-flex flex-wrap align-items-center text-small w-100 ">
              {Rules ? (
                <FareRules Rules={Rules} departureFlight={selectedFlight} />
              ) : (
                <Loader />
              )}
            </div>
          </Modal>
        )}
        </>
      );
    }

    return (
      <div
        onMouseOver={() => setExpand(true)}
        onMouseOut={() => setExpand(false)}
        onClick={() =>
          selected && selected.key === fare.key
            ? onClick(undefined)
            : onClick({ flight: flight, fare: fare })
        }
        className={`${
          selected && selected.key === fare.key
            ? "fares-selected"
            : Expand
            ? "fares"
            : "fares-hidden"
        } p-3 ps-4 pe-4 border-top`}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h6 className="fw-bold me-3 mb-0">{fare.type.replace("_", " ")}</h6>
            <div className="d-flex flex-wrap align-center mt-2">
              <div className="text-small" style={{ marginRight: 12 }}>
                🤑 {parseInt(fare.adult.publishedFare / 10, 10)} coins
              </div>
            </div>
          </div>
          <div>
            <h6
              className={`fw-bold text-end ${
                index === 0 ? "text-success" : ""
              }`}
            >
              Rs. {Math.ceil(fare.adult.publishedFare)} /{" "}
              <i className="fas fa-user" />
            </h6>
            <p
              className="m-0 ms-2"
              style={{
                 fontSize: 14,
                  color: "gray",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setselectedFlight({ flight: flight, fare: fare });
                setFareRuleModel(true);
              }}
            >
              View Details
            </p>
          </div>
        </div>
        <div>
          {fare.message ? (
            <div className="text-muted  text-truncate text-tiny mt-1">
              {fare.message}
            </div>
          ) : (
            <></>
          )}
        </div>
        {fareRuleModel && (
          <Modal
            onClose={() => setFareRuleModel(false)}
            title="Flight  details"
            noButtons={true}
          >
            <div className="d-flex flex-wrap align-items-center text-small w-100 ">
              {Rules ? (
                <FareRules Rules={Rules} departureFlight={selectedFlight} />
              ) : (
                <Loader />
              )}
            </div>
          </Modal>
        )}
      </div>
    );
  });
}

export default Fares;
